<mat-card>
  <span class="summary-headline">Stellen Sie Ihr Paket zusammen</span>

  <hr>

  @let choice = choiceSlot();
  @let free = freeSlot();

  @if (choice && free) {
    <div class="wrapper-status">
      @for (stepAmount of choice.thresholdSteps; track stepAmount; let index = $index; let last = $last) {
        @let freeStepAmount = free.thresholdSteps[index];
        @let choiceReached = choice.thresholdStepReachedIndex === index;
        @let choiceFocus = choice.thresholdStepReachedIndex < index && free.thresholdStepReachedIndex === index - 1;
        @let freeReached = free.thresholdStepReachedIndex === index && choiceReached;
        @let freeFocus = free.thresholdStepReachedIndex < index && choiceReached;

        <div class="wrapper-step-status">
          <div
            class="step-status-item step-status-item-choice"
            [class.step-status-item-focus]="choiceFocus"
            [class.step-status-item-reached]="choiceReached">
            <ui-icon faName="check" faStyle="light"></ui-icon>
            @if (last) {
              {{ stepAmount }}+
            } @else {
              {{ stepAmount }}
            }
            Artikel
          </div>

          <div
            class="step-status-item step-status-item-free"
            [class.step-status-item-focus]="freeFocus"
            [class.step-status-item-reached]="freeReached">
            <ui-icon faName="gift" faStyle="light"></ui-icon>
            {{ freeStepAmount }} Gratisartikel
          </div>
        </div>
      }
    </div>
  }


  <span class="free-info-text">
  *Gratisartikel können erst ausgewählt werden, wenn die erforderlich Anzahl an Pflichtartikeln ausgewählt wurde.
</span>
</mat-card>
